module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bs25gh/tc-custom/9781473844018.jpg?1726574089365",
      "alt": "This image is the cover for the book Royal Arsenal Railways"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Royal Arsenal Railways\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Mark Smithers has written a number of definitive books and magazine features on the history of locomotive construction and the development of narrow gauge railways. This book looks at the history and development of railways at the Royal Arsenal Woolwich, which evolved from humble roots in the 1820s into three separate railway systems, serving the Gun Factory, Laboratory and Carriage Department. The three systems originally had their own fleet of locomotives and rolling stock and were constructed using three different track gauges: standard gauge, 2ft and 18in. The Arsenal and its railways played a major role in both world wars and continued to hold an important place in gun and propellant manufacture until the late 1950s, when the complex was gradually run down. The Royal Arsenal and its railways were finally closed in 1967, when the last train of material left the site. This book covers the history of the system from its beginnings through to its demise and also details the significant remains of a once mighty network.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mark Smithers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Mark Smithers has had a lifelong interest in railway history, particularly in the field of the work of British private locomotive manufacturers during the nineteenth century. He has written two books and many magazine features on the subject over a period of three decades, and is currently a regular contributor to well-known periodicals covering the topic in detail.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0